import React, { FC, useEffect, useRef, useState } from "react"
import _ from "lodash"
import { RouteComponentProps } from "@reach/router"
// PR
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
// Components
import { field as _field } from "components/table/lib/column-field"
import SearchHeader from "components/table/search-header"
import { Toolbar } from "components/subnav"
import {
  TableAutomation } from "components/table/table-automation"
// Data
import api_match from "data/interface/api"
import assetAttributeService from "data/asset-attribute"
import propertyService from "data/property"
// Styles
import DataTable_s from "components/table/data-table-styles"
import { PropertyAssetAttributes_s } from "components/property/asset-attributes/asset-attributes-styles"

const PropertyAssetAttributes:FC<RouteComponentProps> = (props) => {
  const usePrevious = (value) =>{
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }
  const [assetAttributes, setAssetAttributes] = useState<object[]>([])
  const [searchFilter, setSearchFilter] = useState<string>("")
  const prevSearch = usePrevious(searchFilter);
  const tableRef = useRef() as React.MutableRefObject<DataTable>
  const field = _field('assetattribute')

  useEffect(() => {
    const propertySubscription = propertyService.stream().subscribe(data => {
      api_match(
        data,
        init  => {},
        ok    => {
          const currentProperty = _.find(data.value, {propertyid: JSON.parse(localStorage.property)})
          if (currentProperty['assetid']){
            assetAttributeService.fetch(currentProperty['assetid'])
          } else {
            setAssetAttributes([])
          }
        },
        err   => {},
        fetch => {}
      )
    })

    const assetAttributeSubscription = assetAttributeService.stream().subscribe(data => {
      api_match(
        data,
        init  => {},
        ok    => {
          setAssetAttributes(data.value)
        },
        err   => {},
        fetch => {}
      )
    })

    return function cleanup() {
      assetAttributeSubscription.unsubscribe()
      propertySubscription.unsubscribe()
    }
  }, [JSON.parse(localStorage.property)])

  useEffect(() => {
    if (prevSearch !== "" && searchFilter === "") _.invoke(tableRef, 'current.filter', '', 'contains');
    else if (searchFilter !== "") _.invoke(tableRef, 'current.filter', searchFilter, 'contains');
    else return
  }, [searchFilter])

  const rowClassName = (rowData) => {
    return {"" : rowData}
  }

  return (
    <PropertyAssetAttributes_s>
      <Toolbar>
        <SearchHeader setSearchFilter={setSearchFilter} />
      </Toolbar>
      {assetAttributes?.length > 0 && <DataTable_s id={`${props['tableId']}-scrollable-container`}>
        <DataTable
          globalFilter={searchFilter}
          id='assetattribute'
          ref={tableRef}
          value={assetAttributes}
          paginator={true}
          rows={20}
          rowsPerPageOptions={[10, 20, 50, 100, 500]}
          scrollable={true}
          frozenWidth="45px"
          paginatorPosition="bottom"
          rowClassName={rowClassName}
          stateStorage="custom"
          customSaveState={state => localStorage.setItem("primereact-table-preferences", JSON.stringify({rows: state.rows}))}
          customRestoreState={() => JSON.parse(localStorage.getItem("primereact-table-preferences")!)}
        >
          <Column header="#" frozen={true} style={{minWidth: "45px"}}
            body={(rowData, props) => props.rowIndex + 1}
          />
          <Column style={{minWidth: "250px"}} className="p-editable-column"
            header="Code"
            {...field('code')}
          />
          <Column style={{minWidth: "250px"}} className="p-editable-column"
            header="Name"
            {...field('name')}
          />
          <Column style={{minWidth: "250px"}} className="p-editable-column"
            header="Value"
            {...field('value')}
          />
        </DataTable>
        { assetAttributes.length ? <TableAutomation tableId={props['tableId']}/> : null }
      </DataTable_s> }
    </PropertyAssetAttributes_s>
  )
}

export default PropertyAssetAttributes

